<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 20px 0">
          <el-input v-model="serchat" placeholder="请输入关键字" maxlength="30" style="width: 300px;"></el-input>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown" class="project-dropdown">
              <el-dropdown-item command=",全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item._id+','+item.name">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown split-button type="primary" @command="commandStateEvent">
            <span v-html="stateTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item command="启用">启用</el-dropdown-item>
              <el-dropdown-item command="禁用">禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
          <el-button type="success" @click="enableDisable(1)" plain>批量启用</el-button>
          <el-button type="danger" @click="enableDisable(2)" plain>批量禁用</el-button>
        </div>
      </el-header>
      <el-main>
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="token_name"
              label="接口名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="relation_parms"
              label="关联参数"
              width="200">
            </el-table-column>
            <el-table-column
              prop="im_username"
              label="账号"
              width="200">
            </el-table-column>
            <el-table-column
              prop="acceptance"
              label="接纳人数限制"
              width="120">
            </el-table-column>
            <el-table-column
              prop="state"
              label="自动回复"
              width="110">
              <template slot-scope="scope">
                <el-tag v-html="scope.row.automatic_response?'自动':'关闭'" :type="(scope.row.automatic_response?'success':'danger')"></el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="reply_text"
              label="回复文本"
              width="200">
            </el-table-column>
            <el-table-column
              prop="state"
              label="自动结束"
              width="110">
              <template slot-scope="scope">
                <el-tag v-html="scope.row.automatic_end_dialogue?'自动':'关闭'" :type="(scope.row.automatic_end_dialogue?'success':'danger')"></el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="end_dialogue_time"
              label="结束对话时长"
              width="120">
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="count"
              label="状态操作"
              width="120">
              <template slot-scope="scope">
                <el-button @click="{{(scope.row.state?cz(1,scope.row._id):cz(2,scope.row._id))}}" type="text" size="small">{{(scope.row.state?'停用':'启用')}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="updateUser(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import apiController from '@/api/im'
  export default {
    data () {
      return {
        serchat:"",
        dropdownTitle:"请选择",
        stateTitle:"全部",
        dropdownId:"",
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        dropdownList:[]
      }
    },
    methods:{
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      commandEvent(command) {
        let _command = command.split(',')
        this.dropdownId = _command[0]
        this.dropdownTitle = _command[1]
      },
      commandStateEvent(command) {
        this.stateTitle = command
      },
      cz:async function(val,id){
        await apiController
          .updateOneAccount({
            params:{
              val:val,
              id:id
            }
          })
          .then(res => {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.isAjax();
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
      },
      enableDisable:async function(val){
        await apiController
          .updateAccount({
            params:{
              val:val,
              drop:this.dropdownId,
              serchat:this.serchat,
              state:this.stateTitle,
            }
          })
          .then(res => {
            this.$message({
              message: '批量修改成功',
              type: 'success'
            });
            this.isAjax();
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      addInterface:async function(){
        await apiController
          .getInterface({
            params:{
            }
          })
          .then(res => {
            let { data, code } = res.data
            if (code === 'Success'){
              this.dropdownList = data
            }
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
      },
      isAjax:async function(){
        await apiController
          .getImAccount({
            params:{
              drop:this.dropdownId,
              serchat:this.serchat,
              state:this.stateTitle,
              "count":this.count0,
              "page":this.currentPage0
            }
          })
          .then(res => {
            let { data, code } = res.data
            if (code === 'Success'){
              this.tableData = data
            }
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
        this.divHeight = window.innerHeight-138;
      }
    },
    mounted(){
      this.addInterface()
      this.isAjax();
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
  }
  .project-dropdown{
    height:300px !important;
    overflow: auto;
  }
  .project-dropdown::-webkit-scrollbar
  {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
  }
  .project-dropdown::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }
  .project-dropdown li{
    margin-bottom: 0px !important;
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/im/imAccount.vue